import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PaidPayment, PaymentProductService, PaymentProduct } from 'src/models/payment';
import { ProviderInfoPayment } from 'src/models/provider';
import { validationRules } from './validationRules';
import { checkErrorForm } from 'src/utils/ehrValidators';
// import FreeProduct from './FeeProduct';
import PaidProduct from './PaidProduct';
// import FreeProductMessage from './FeeProductMessage';
import CheckoutForm from './CheckoutForm';
import { clearSessionStorage, removeWorkflowContextData } from 'src/utils/workflow';
import { ErrorMessageType, WorkflowContext } from '../../utils/constValues';
import Workflow from 'src/models/workflow';
import { RegistrationStep } from '../../utils/constValues';
import { getCurrentStepRouter } from 'src/utils/workflow';
import PopupConfirm from '../shared/PopupConfirm';
// import { DirtyInformer } from '../shared/dirty-data';

export interface StateFromProps {
    registrationId: string;
    workflow: Workflow;

    provider: ProviderInfoPayment;
    submitting: boolean;
    submitted: boolean;

    //data from Vendor
    paymentProducts: Array<PaymentProduct>;
    errorMessage: string;
    messageType: string;
}

export interface DispatchFromProps {
    updateWorkflow: (workflow: Workflow) => void;
    submitPaidProducts: (paidProducts: PaidPayment) => void; // not use
    submitToVendor: (registrationId: string) => void;
    getPaymentProducts: () => void;
    resetSubmitStatus: () => void;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

export interface State {
    hasError: boolean;
    triggerCheckError: boolean;

    freeProductService: PaymentProductService;
    paidProductService: PaymentProductService;

    paidPayment: PaidPayment;

    localSubmitting: boolean;

    showPopup: boolean;
    showErrorPopup: boolean;
    isCleanOutAllInformation: boolean;
    errorPopupType: string; // ERROR_FROM_STRIPE, ERROR_FROM_INTERNAL_SYSTEM
}

class Payment extends React.Component<Props, State> {
    elCheckoutForm: CheckoutForm | null;
    constructor(props: Props) {
        super(props);
        window.document.title = 'Payment';
        this.state = this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            hasError: checkErrorForm(validationRules, this.initialPaidPayment()),
            triggerCheckError: false,
            freeProductService: { ACEHR: true, ACScripts: true, ACBilling: true },
            paidProductService: { ACEHR: false, ACScripts: true, ACBilling: false },
            paidPayment: this.initialPaidPayment(),
            localSubmitting: false,
            showPopup: false,
            showErrorPopup: false,
            isCleanOutAllInformation: false,
            errorPopupType: ''
        };
    }

    initialPaidPayment = (): PaidPayment => {
        const { provider, registrationId } = this.props;
        let payment: PaidPayment = {
            registrationId: registrationId ?? '',
            totalAmount: 0,
            paymentAccountName: provider ? provider.physicianName : '',
            email: '',
            stripeTokenId: '',
            creditCardName: '',
            expirationDate: '',
            securityCode: '',
            paidProductService: {} as PaymentProductService
        };

        return payment;
    }

    componentDidMount() {
        this.props.getPaymentProducts();
    }

    componentWillReceiveProps(nextProps: Props) {
        // if (!this.props.submitted && nextProps.submitted) {
        //     this.updateWorkflowToAttachmentsStep();
        // }
        
        if (!this.props.submitted && nextProps.submitted) {
            this.props.resetSubmitStatus();
            this.setState({ showPopup: true });
        }
        // if submit failed
        else if (this.props.submitting && !nextProps.submitting && !nextProps.submitted
            && nextProps.errorMessage && nextProps.messageType) {
            this.setState({ showErrorPopup: true, errorPopupType: nextProps.messageType });

            if (nextProps.messageType===ErrorMessageType.ERROR_FROM_INTERNAL_SYSTEM) {
                this.setState({
                    isCleanOutAllInformation: true
                });
            }
        }
    }

    handleChange = (value: string | number, field: string): void => {
        this.setState((prevState: State) => {
            const newPaidPayment: PaidPayment = {
                ...prevState.paidPayment,
                [field]: value
            };

            return {
                ...prevState,
                paidPayment: newPaidPayment,
                hasError: checkErrorForm(validationRules, newPaidPayment)
            };
        });
    }

    updateFreeProductService = (freeProductService: PaymentProductService): void => {
        this.setState({ freeProductService: freeProductService });
    }

    updatePaidProductService = (paidProductService: PaymentProductService): void => {
        this.setState({ paidProductService: paidProductService });
    }

    onlyFreeProducts = (): boolean => {
        const { paidProductService, paidPayment } = this.state;
        return (JSON.stringify(paidProductService) === JSON.stringify({ ACEHR: false, ACScripts: false, ACBilling: false })
            && JSON.stringify(paidPayment) === JSON.stringify(this.initialPaidPayment()));
    }

    updateWorkflowToAttachmentsStep = (): void => {
        const { workflow } = this.props;
        if (workflow != undefined) {
            let newWorkflow = workflow;
            newWorkflow.currentStep = RegistrationStep.Summary;
            this.props.updateWorkflow(newWorkflow);
            this.props.history.push(getCurrentStepRouter(newWorkflow));
        }
    }

    closeErrorPopup = (): void => {
        this.setState({ showErrorPopup: false });

        const {isCleanOutAllInformation} = this.state;
        if (isCleanOutAllInformation) {
            removeWorkflowContextData(WorkflowContext.WorkFlowData);
            clearSessionStorage();
            this.props.history.push('/registration/provider');

            this.setState({
                isCleanOutAllInformation: false
            });
        }
    }

    submitPayment = async (): Promise<void> => {
        const { hasError, triggerCheckError, paidPayment, paidProductService } = this.state;
        const { provider } = this.props;
        // if (this.onlyFreeProducts()) {
        //     // By default is free mode
        //     // Just update workflow and go to next step
        //     this.updateWorkflowToAttachmentsStep();
        // }
        // else {
        //     if (!hasError) {
        //         if (this.elCheckoutForm) {
        //             let { stripeTokenId, createTokenError } = await this.elCheckoutForm.checkCreditCard();
        //             if (createTokenError && createTokenError !== '') {
        //                 alert(`At the Credit Card field: ` + createTokenError);
        //             }
        //             else {
        //                 if (JSON.stringify(paidProductService) === JSON.stringify({ ACEHR: false, ACScripts: false, ACBilling: false })) {
        //                     alert(`You must select at least one paid product (ACEHR, ACScripts or ACBilling)`);
        //                 }
        //                 else {
        //                     let newPaidPayment = paidPayment;
        //                     newPaidPayment.stripeTokenId = stripeTokenId;
        //                     newPaidPayment.paidProductService = paidProductService;

        //                     this.props.submitPaidProducts(newPaidPayment);
        //                 }
        //             }
        //         }
        //     } else {
        //         this.setState({ triggerCheckError: !triggerCheckError });
        //     }
        // }

        // Only use Paid Product. Must fill data
        this.setState({ localSubmitting: true });
        if (!hasError) {
            if (this.elCheckoutForm) {
                let { stripeTokenId, createTokenError } = await this.elCheckoutForm.checkCreditCard();
                if (createTokenError && createTokenError !== '') {
                    alert(`At the Credit Card field: ` + createTokenError);
                }
                else {
                    if (JSON.stringify(paidProductService) === JSON.stringify({ ACEHR: false, ACScripts: false, ACBilling: false })) {
                        alert(`You must select at least one paid product (ACEHR, ACScripts or ACBilling)`);
                    }
                    else {
                        let newPaidPayment = paidPayment;
                        newPaidPayment.email = provider.physicianEmail;
                        newPaidPayment.stripeTokenId = stripeTokenId;
                        newPaidPayment.paidProductService = paidProductService;

                        this.props.submitPaidProducts(newPaidPayment);
                    }
                }
            }
        } else {
            this.setState({ triggerCheckError: !triggerCheckError });
        }
        this.setState({ localSubmitting: false });
    }

    submitToVendor = (): void => {
        const { registrationId } = this.props;
        // const { hasError } = this.state;
        if (registrationId) {
            this.props.submitToVendor(registrationId);
        }
    }

    confirm = (): void => {
        this.setState({ showPopup: false });
        removeWorkflowContextData(WorkflowContext.WorkingRegistrationId);
        removeWorkflowContextData(WorkflowContext.PROVIDER_INFO_PAYMENT);
        removeWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT);
        removeWorkflowContextData(WorkflowContext.WorkFlowData);
        removeWorkflowContextData(WorkflowContext.ATTEMPT_COUNTER_STEP_ONE);
        removeWorkflowContextData(WorkflowContext.ATTEMPT_COUNTER_STEP_TWO);
        window.onbeforeunload = null;
        window.location.replace('https://www.acscripts.com');
    }

    render() {
        const { submitting, provider, paymentProducts } = this.props;
        const { showPopup, showErrorPopup, paidPayment, triggerCheckError, localSubmitting, errorPopupType } = this.state;
        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                {/* <h5 className="payment-options-header">{`There are two options: Free Products and Paid Products. Both options will have 3 months free trial period.`}</h5> */}
                                                <div className="flex-full card-sp" style={{ maxHeight: '92%' }}>
                                                    <h5 className="card-title-sp">Provider Payment</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            {
                                                                submitting ?
                                                                    <div className="loading-center">
                                                                        <table className="table table-borderless">
                                                                            <tbody className="spinner-bg d-flex">
                                                                                <tr className="text-center">
                                                                                    <td className="alert alert-info" role="alert">
                                                                                        <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />Submitting...</span>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    :
                                                                    <div className="h-100">
                                                                        {/* <FreeProduct
                                                                            provider={provider}
                                                                            updateFreeProductService={this.updateFreeProductService}
                                                                        /> */}
                                                                        {/* <FreeProductMessage submitting={submitting} provider={provider}/> */}
                                                                        <PaidProduct
                                                                            provider={provider}
                                                                            paidPayment={paidPayment}
                                                                            triggerCheckError={triggerCheckError}
                                                                            submitting={submitting || localSubmitting}
                                                                            paymentProducts={paymentProducts}
                                                                            updatePaidProductService={this.updatePaidProductService}
                                                                            handleChange={this.handleChange}
                                                                            refCheckoutForm={el => this.elCheckoutForm = el}
                                                                        />
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" disabled={submitting} onClick={this.submitPayment}><i className="fa fa-send" /> Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <DirtyInformer screenName="" hasDirty={false}/> */}
                {/* There was an error in your credit card payment information */}
                <PopupConfirm
                    showPopup={showErrorPopup}
                    shouldHideNoButton={true}
                    customTextYesButton={' OK'}
                    loading={false}
                    inStepFour={true}
                    onCancel={() => { }}
                    executeFunction={this.closeErrorPopup}
                    stepFourType={errorPopupType}
                />

                {/* Success popup */}
                <PopupConfirm
                    showPopup={showPopup}
                    title={`Registration confirm`}
                    shouldHideNoButton={true}
                    loading={false}
                    onCancel={() => { }}
                    executeFunction={this.confirm}
                />
            </main>
        );
    }
}

export default Payment;


// WEBPACK FOOTER //
// ./src/components/Payment/Payment.tsx